import { computed, inject, Injectable } from '@angular/core';
import {
  mapToUserNotification,
  UserNotification,
} from '../../models/user-notification';
import {
  addDoc,
  collection,
  doc,
  DocumentData,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AUTH, FIRESTORE } from '../../firebase-injection';

@Injectable({
  providedIn: 'root',
})
export class NotificationAdapterService {
  firestore = inject(FIRESTORE);
  authId = inject(AUTH).currentUser?.uid;
  notificationCollection = collection(
    this.firestore,
    `notifications/${this.authId}/items`
  );

  notifications$ = toSignal(
    collectionData(
      query(this.notificationCollection, where('isActive', '==', true)),
      {
        idField: 'id',
      }
    ).pipe(
      map((notifications: (DocumentData & { id?: string })[]) => {
        return notifications
          .map((notification) => mapToUserNotification(notification))
          .sort(
            (a, b) =>
              (b.createdAt?.getTime() ?? 0) - (a.createdAt?.getTime() ?? 0)
          );
      })
    ),
    {
      initialValue: [],
    }
  );

  totalUnReadNotifications$ = computed(
    () => this.notifications$().filter((note) => !note?.read).length
  );

  saveNotification(userId: string, notification: UserNotification) {
    addDoc(
      collection(this.firestore, 'notifications', userId, 'items'),
      notification
    ).then(() => {});
  }

  markNotificationAsRead(notificationId: string): Promise<void> {
    const notificationRef = doc(
      this.firestore,
      `notifications/${this.authId}/items/${notificationId}`
    );
    return updateDoc(notificationRef, {
      read: true,
    });
  }

  async deactivateAllNotifications() {
    (
      await getDocs(
        collection(this.firestore, `notifications/${this.authId}/items`)
      )
    ).docs.map((docSnap) => updateDoc(docSnap.ref, { isActive: false }));
  }
}
